
import { mapState } from 'pinia';
import SeoDataMixin from '@Mixins/seo-data';
import errorHandler from '@Utils/error-handler';
import { useUser } from '@Stores/user';
import { adapterFaqDetails } from '@Adapters/cms/faq.adapter';

export default {
  name: 'FaqDetailsPage',
  mixins: [SeoDataMixin],
  data() {
    return {
      details: undefined,
      seo: undefined,
      shopIdConsult: undefined,
    };
  },
  computed: {
    ...mapState(useUser, ['site']),
  },
  watch: {
    site() {
      this.fetchCMSData();
    },
  },
  mounted() {
    this.fetchCMSData();
  },
  methods: {
    async fetchCMSData() {
      const shopIdConsult = this.$route?.query?.shopIdConsult;

      try {
        const data = await this.$publicAPI.cms.getEntry('faq_thematic_page', {
          params: {
            targetPage: this.$route.path,
          },
          shopIdConsult,
        });
        const topicData = adapterFaqDetails(data, this);

        if (!topicData) {
          return;
        }

        this.details = topicData.details;
        this.seo = topicData.seo;
        this.shopIdConsult = shopIdConsult;

        return { ...topicData, shopIdConsult };
      } catch (err) {
        errorHandler(err, this, {
          logOnly: true,
          path: 'pages.faq.details.fetchCMSData',
        });
      }
    },
  },
};
